const contact = () => {
  if (window.wp_message_submit) {
    const anchor = document.querySelector("#wp-contact-sent");
    anchor.scrollIntoView();
  }

  document.addEventListener("wp_contact_estate_sent", () => {
    const anchor = document.querySelector("#wp-contact-sent");
    anchor.scrollIntoView();
  }, false);

  if (document.querySelector(".wpcf7")) {
    const flashError = [
      "m-0",
      "mt-8",
      "bg-danger-500",
      "text-white",
      "px-4",
      "py-3",
      "relative",
    ];

    const flashSuccess = [
      "m-0",
      "mt-8",
      "bg-brand-500",
      "text-white",
      "px-4",
      "py-3",
      "relative",
    ];

    document.addEventListener("wpcf7invalid", () => {
      document.querySelector(".wpcf7-response-output").classList.add(...flashError);
    }, false);
    document.addEventListener("wpcf7spam", () => {
      document.querySelector(".wpcf7-response-output").classList.add(...flashError);
    }, false);
    document.addEventListener("wpcf7mailfailed", () => {
      console.log(document.querySelector(".wpcf7-response-output"));
      document.querySelector(".wpcf7-response-output").classList.add(...flashError);
    }, false);
    document.addEventListener("wpcf7mailsent", () => {
      document.querySelector(".wpcf7-response-output").classList.add(...flashSuccess);
    }, false);
  }
};

export default contact;
